






















import { Component, Prop, Vue } from "vue-property-decorator";
import { ICustomFieldValue } from "@/models/brands";
import { BASE_URL } from "@/store/modules/api";
import { DataModules } from "@/store/modules/data";

@Component
export default class CustomFieldsView extends Vue {
  // Props
  @Prop({ required: true, default: () => [] })
  public value!: ICustomFieldValue[];
  // Getters
  public get mappedFields() {
    const _ = this.$_;
    return _.map(this.value, field => {
      let value, component;
      switch (field.field.type) {
        case 5: // Textarea
        case 6: // Date
        case 7: // Number
        case 1: // Text
          value = field.value;
          break;
        case 3: // Select
          value = _.get(
            field.field.values.find(f => f.value === field.value),
            "label"
          );
          break;
        case 4: // Checkbox
          value = field.value ? this.$t("_.yes") : this.$t("_.no");
          break;
        case 8: // Image
          component = {
            is: "img",
            props: {
              src: this.imagePathFromHash(field.value),
              class: "custom-field-image has-cursor-pointer"
            },
            on: {
              click: () => {
                this.$store.dispatch(
                  `data/${DataModules.IMAGES}/openImagePreviewModal`,
                  {
                    props: {
                      imagePath: `${this.imagePathFromHash(
                        field.value
                      )}?size=original`
                    }
                  }
                );
              }
            }
          };
          break;
      }
      return {
        id: field.id,
        name: field.field.name,
        order: field.field.order,
        component,
        value
      };
    }).filter(i => !!i);
  }

  public get orderedFields() {
    return this.$_.orderBy(this.mappedFields, ["order", "asc"]);
  }

  // Methods
  public imagePathFromHash(hash) {
    return `${BASE_URL}api/images/${hash}/download`;
  }
}
